module.exports = __webpack_public_path__ + "img/396091-73-9.9b4028e9.png";